import { Step, StepLabel, Stepper, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import MobileStepper from '@/components/MobileStepper';

interface Props {
    steps: string[];
    currentStep: number;
}

export default function IntakeFormStepper({ steps, currentStep }: Props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return isMobile ? (
        <MobileStepper
            progress={currentStep}
            totalSteps={steps?.length}
            currentPage={steps[currentStep]}
            nextPage={steps[currentStep + 1]}
        />
    ) : (
        <Stepper
            sx={{
                width: '100%',
                '.MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
                    marginTop: '4px',
                },
                '.MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel': {
                    color: 'white',
                },
                '.MuiStepLabel-label.Mui-active': {
                    color: theme.palette.neutral.white,
                },
                '.MuiStepLabel-iconContainer.Mui-disabled svg > circle': {
                    fill: theme.palette.neutral.black,
                },
                '.MuiStepLabel-iconContainer.Mui-disabled .MuiStepIcon-text': {
                    fill: theme.palette.neutral.N_500,
                },
                '.MuiStepLabel-iconContainer.Mui-completed path': {
                    fill: 'white',
                },
                '.MuiStepConnector-line': {
                    borderColor: theme.palette.neutral.black,
                },
            }}
            activeStep={currentStep}
            alternativeLabel
        >
            {steps.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}
